import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, gradient, greys } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

export const container: CSSProperties = {
  position: "relative",
  backgroundColor: greys.white,
  height: 80,
  width: "100%",
};

export const absoluteContainer: CSSProperties = {
  position: "absolute",
  display: "flex",
  flexDirection: "column",
  zIndex: 6,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",

  "@media (maxWidth: 768px)": {
    boxShadow: "none",
    borderStyle: "solid",
    borderWidth: 0,
    borderBottomWidth: 1,
    borderColor: greys.borderGrey,
  },
};

export const rowFlexedContainer: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  flex: 1,
  alignItems: "center",
  padding: spacing.lg,
};

export const gradientBar: CSSProperties = {
  height: 4,
  width: "100%",
  flexShrink: 0,
  background: gradient,
  display: "none",

  "@media (maxWidth: 768px)": {
    display: "block",
  },
};

export const logoContainer: CSSProperties = {
  cursor: "pointer",
};

export const logo: CSSProperties | { [key: string]: CSSProperties } = {
  width: 172,
  "@media (maxWidth: 768px)": {
    width: 160,
  },
};

export const logout: CSSProperties = {
  justifyContent: "flex-end",
  marginLeft: "auto",
};

export const betaLabelContainer: CSSProperties = {
  borderRadius: 2,
  backgroundColor: colors.blueCool.lightest,
  color: colors.blueCool.darker,
  padding: 6,
  fontWeight: "bold",
  fontSize: 12,
  marginLeft: 14,
};

export const styles = {
  container,
  absoluteContainer,
  logoContainer,
  rowFlexedContainer,
  gradientBar,
  logo,
  logout,
  betaLabelContainer,
};
